import React from 'react';
import type { DynamicTextTagProps } from '.';
import type { TagTextProps } from './components';
import { TagText } from './components';

export const getStandardDynamicTagText = (props: TagTextProps): DynamicTextTagProps => {
    const { iconName, text, href } = props;

    return {
        longText: <TagText iconName={iconName} text={text} href={href} />,
        shortText: <TagText iconName={iconName} href={href} />,
        title: text,
        testId: `tag-${text?.toLowerCase()}`
    };
};
